import { utils } from "../../utils";
const iniUser = {
    isMenuOpen: { left: false },
    isLoginsOpen: false,
    msgModal: { isOpen: false, msg: '', title: '' }
}

const reducer_ALL = (state = iniUser, action) => {

    switch (action.type) {
        case utils.constants.MENU_TOGGLE: {
            return {
                ...state,
                isMenuOpen: action.payload.isMenuOpen
            }
        }
        case utils.constants.MENU_OPEN: {
            return {
                ...state,
                isMenuOpen: action.payload.isMenuOpen
            }
        }
        case utils.constants.LOGINS_OPENER: {
            // console.log('action.payload:', action.payload)
            return {
                ...state,
                isLoginsOpen: action.payload
            }
        }
        case utils.constants.MSG_MODAL_OPENER: {
            console.log('action.payload:', action.payload) 
            return {
                ...state,
                msgModal: { ...action.payload }
            }
        }


        default:
            return { ...state };
    }
}

export default reducer_ALL